import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CommonService } from '@modules/shared/services/common.service';
import { DEV_TOOLBAR_CONSTANTS } from '@components/dev-toolbar/dev-toolbar.constants';

@Component({
    selector: 'app-dev-toolbar',
    imports: [CommonModule],
    templateUrl: './dev-toolbar.component.html',
    styleUrls: ['./dev-toolbar.component.scss']
})
export class DevToolbarComponent {
  readonly constants = DEV_TOOLBAR_CONSTANTS;
  readonly cs = inject(CommonService);

  isOpen = false;

  togglePanel(): void {
    this.isOpen = !this.isOpen;
  }

  onIsBrowserChange(checked: boolean): void {
    this.cs.isBrowser = checked;
  }

  simulateHydration(): void {
    this.cs.isBrowser = false;
    setTimeout(() => {
      this.cs.isBrowser = true;
    }, this.constants.timing.hydrationDelayMs);
  }
}
